import React from 'react'

import cl from './ExtraList.module.scss'

interface ExtraListProps {
	items?: string[]
	className?: string
}

export const ExtraList: React.FC<ExtraListProps> = ({ className }) => {
	return (
		<section className={`${cl.section} ${className || ''}`}>
			<ul className={cl.list}>
				<li>
					<p className={cl.title}>
						Уже сейчас в наших розничных магазинах вас ждут прототипы всей линейки iPhone 17, представленные в разных
						цветах.
					</p>
					<p className={cl.subtitle}>
						Чтобы стать одним из первых обладателей iPhone 17, выберите понравившуюся модель, оформите и оплатите заказ.
						Поступление смартфонов в магазины iPort ожидается в конце месяца. Сразу после этого с вами свяжется наш
						контакт-центр и проинформирует о сроках получения вашего заказа.
					</p>
				</li>
			</ul>
		</section>
	)
}
